import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "donePage" };
const _hoisted_2 = { class: "bulletList" };
const _hoisted_3 = { class: "bulletRow" };
const _hoisted_4 = { class: "bulletIcon" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "bulletRow" };
const _hoisted_7 = { class: "bulletIcon" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "bulletRow" };
const _hoisted_10 = { class: "bulletIcon" };
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "anchor-bottom" };
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInDonePage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, getEmployer } = useCustomer();
        const { getQuestionnaireByKey } = useQuizApi();
        const starting = ref(false);
        function onLoad() {
            // Fetch the employer too so referralsEnabled is known by the time
            // the user taps continue.
            getCustomer(() => {
                if (state.customer?.employerID)
                    getEmployer(state.customer.employerID, null, true);
            });
        }
        // Same hand-off as PersonalisationLandingPage
        function startSurvey() {
            if (state.employer?.referralsEnabled) {
                router.push('/Redeem');
            }
            else {
                starting.value = true;
                getQuestionnaireByKey('GOALS', (q) => {
                    router.push({ path: '/Questionnaire/' + q.id, query: { theme: 'dark', allowBack: 'false' } });
                }, () => {
                    starting.value = false;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: 0,
                    transparent: true
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[3] || (_cache[3] = _createStaticVNode("<svg class=\"doneGraphic\" viewBox=\"0 0 136 156\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" data-v-6008e8dd><defs data-v-6008e8dd><linearGradient id=\"doneArcGradient\" x1=\"68\" y1=\"4\" x2=\"68\" y2=\"132\" gradientUnits=\"userSpaceOnUse\" data-v-6008e8dd><stop stop-color=\"var(--bright-blue-2)\" data-v-6008e8dd></stop><stop offset=\"1\" stop-color=\"var(--bright-blue-1)\" data-v-6008e8dd></stop></linearGradient></defs><circle cx=\"68\" cy=\"68\" r=\"64\" stroke=\"var(--background-color-primary)\" stroke-opacity=\"0.1\" stroke-width=\"8\" data-v-6008e8dd></circle><circle class=\"doneArc\" cx=\"68\" cy=\"68\" r=\"64\" stroke=\"url(#doneArcGradient)\" stroke-width=\"8\" stroke-linecap=\"round\" transform=\"rotate(-90 68 68)\" data-v-6008e8dd></circle><path d=\"M89 92C90.6569 92 92 93.3431 92 95C92 96.6569 90.6569 98 89 98H47C45.3431 98 44 96.6569 44 95C44 93.3431 45.3431 92 47 92H89ZM68 36C81.2548 36 92 46.7452 92 60C92 73.2548 81.2548 84 68 84C54.7452 84 44 73.2548 44 60C44 46.7452 54.7452 36 68 36Z\" fill=\"var(--background-color-primary)\" data-v-6008e8dd></path></svg><div class=\"doneHeading\" data-v-6008e8dd><h1 data-v-6008e8dd>You&#39;re in!</h1><p data-v-6008e8dd>We&#39;ll ask a few questions about you, your finances and what you&#39;d like to achieve.</p></div>", 2)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-card.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_5)
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Take control of your finances", -1))
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-card.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_8)
                            ]),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Develop a positive relationship with your money", -1))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-card.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_11)
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Tailored insights and guidance", -1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(MGButton, {
                            text: "Continue",
                            arrow: true,
                            fullWidth: true,
                            disabled: starting.value,
                            onClick: startSurvey
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
